// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteCoreLocationHoursClearManualData, DeleteCoreLocationHoursClearManualResponses, DeleteCoreLocationsDeleteData, DeleteCoreLocationsDeleteResponses, DeleteCoreTagsDeleteData, DeleteCoreTagsDeleteResponses, DeleteCoreWebhooksDeleteData, DeleteCoreWebhooksDeleteResponses, DeleteCrmConfigContactRelationshipTypesDeleteData, DeleteCrmConfigContactRelationshipTypesDeleteResponses, DeleteCrmConfigContactTypesDeleteData, DeleteCrmConfigContactTypesDeleteResponses, DeleteCrmConfigFileCategoriesDeleteData, DeleteCrmConfigFileCategoriesDeleteResponses, DeleteCrmContactFilesDeleteData, DeleteCrmContactFilesDeleteResponses, DeleteCrmContactNotesDeleteData, DeleteCrmContactNotesDeleteResponses, DeleteCrmContactRelationshipsDeleteData, DeleteCrmContactRelationshipsDeleteResponses, DeleteCrmContactsDeleteData, DeleteCrmContactsDeleteResponses, DeleteDisplayDevicesDeleteDeviceData, DeleteDisplayDevicesDeleteDeviceResponses, DeleteDisplayDevicesDeleteOutputData, DeleteDisplayDevicesDeleteOutputResponses, DeleteDisplayDevicesRemoveOutputScheduleData, DeleteDisplayDevicesRemoveOutputScheduleResponses, DeleteDisplayGroupsRemoveData, DeleteDisplayGroupsRemoveResponses, DeleteDisplayGroupsRemoveScheduleData, DeleteDisplayGroupsRemoveScheduleResponses, DeleteDisplayMediaRemoveData, DeleteDisplayMediaRemoveResponses, DeleteDisplayPlaylistsRemoveData, DeleteDisplayPlaylistsRemoveItemData, DeleteDisplayPlaylistsRemoveItemResponses, DeleteDisplayPlaylistsRemoveResponses, DeleteFormsManageDeleteFormData, DeleteFormsManageDeleteFormResponses, DeleteFormsManageDiscardDraftData, DeleteFormsManageDiscardDraftResponses, GetCoreAuditIndexData, GetCoreAuditIndexResponses, GetCoreConfigGetConfigLegacyData, GetCoreConfigGetConfigLegacyResponses, GetCoreConfigGetConsumerConfigData, GetCoreConfigGetConsumerConfigResponses, GetCoreLocationHoursIndexData, GetCoreLocationHoursIndexResponses, GetCoreLocationHoursShowData, GetCoreLocationHoursShowResponses, GetCoreLocationsIndexData, GetCoreLocationsIndexResponses, GetCoreTagsIndexData, GetCoreTagsIndexResponses, GetCoreWebhookDeliveriesShowData, GetCoreWebhookDeliveriesShowResponses, GetCoreWebhooksDeliveriesData, GetCoreWebhooksDeliveriesResponses, GetCoreWebhooksEventTypesData, GetCoreWebhooksEventTypesResponses, GetCoreWebhooksIndexData, GetCoreWebhooksIndexResponses, GetCoreWebhooksShowData, GetCoreWebhooksShowResponses, GetCoreWorkstationsListData, GetCoreWorkstationsListResponses, GetCrmCheckInsListData, GetCrmCheckInsListResponses, GetCrmConfigContactRelationshipTypesIndexData, GetCrmConfigContactRelationshipTypesIndexResponses, GetCrmConfigContactTypesIndexData, GetCrmConfigContactTypesIndexResponses, GetCrmConfigFileCategoriesIndexData, GetCrmConfigFileCategoriesIndexResponses, GetCrmContactFilesDownloadData, GetCrmContactFilesDownloadResponses, GetCrmContactFilesIndexData, GetCrmContactFilesIndexResponses, GetCrmContactNotesHistoryData, GetCrmContactNotesHistoryResponses, GetCrmContactNotesIndexData, GetCrmContactNotesIndexResponses, GetCrmContactRelationshipsIndexData, GetCrmContactRelationshipsIndexResponses, GetCrmContactsIndexData, GetCrmContactsIndexResponses, GetCrmContactsShowData, GetCrmContactsShowResponses, GetDisplayDevicesGetData, GetDisplayDevicesGetResponses, GetDisplayDevicesListData, GetDisplayDevicesListResponses, GetDisplayGroupsGetData, GetDisplayGroupsGetResponses, GetDisplayGroupsListData, GetDisplayGroupsListResponses, GetDisplayMediaListData, GetDisplayMediaListResponses, GetDisplayMediaPublicRedirectData, GetDisplayMediaPublicRedirectResponses, GetDisplayPlaylistsGetData, GetDisplayPlaylistsGetResponses, GetDisplayPlaylistsListData, GetDisplayPlaylistsListResponses, GetFormsListFormsData, GetFormsListFormsResponses, GetFormsManageGetDefinitionData, GetFormsManageGetDefinitionResponses, GetFormsManageGetFormData, GetFormsManageGetFormResponses, GetFormsManageListDefinitionsData, GetFormsManageListDefinitionsResponses, GetFormsPublicGetFormData, GetFormsPublicGetFormResponses, GetFormSubmissionsGetSubmissionRenderHtmlData, GetFormSubmissionsGetSubmissionRenderHtmlResponses, GetFormSubmissionsGetSubmissionRenderPdfData, GetFormSubmissionsGetSubmissionRenderPdfResponses, GetFormSubmissionsGetSubmissionsData, GetFormSubmissionsGetSubmissionsResponses, GetItFreshdeskBridgePublicGetConfigData, GetItFreshdeskBridgePublicGetConfigResponses, GetItFreshdeskBridgePublicStartSsoData, GetItFreshdeskBridgePublicStartSsoResponses, GetSystemAlertsIndexData, GetSystemAlertsIndexResponses, HeadDisplayMediaPublicHeadData, HeadDisplayMediaPublicHeadResponses, OptionsFormsPublicGetFormPreflightData, OptionsFormsPublicGetFormPreflightResponses, OptionsFormsPublicResolveZipPreflightData, OptionsFormsPublicResolveZipPreflightResponses, OptionsFormsPublicSubmitFormPreflightData, OptionsFormsPublicSubmitFormPreflightResponses, PostCoreEtlExportData, PostCoreEtlExportResponses, PostCoreEtlImportData, PostCoreEtlImportResponses, PostCoreLocationHoursUseSharedData, PostCoreLocationHoursUseSharedResponses, PostCoreLocationsCreateData, PostCoreLocationsCreateResponses, PostCoreTagsCreateData, PostCoreTagsCreateResponses, PostCoreUploadsUploadData, PostCoreUploadsUploadFromScannerData, PostCoreUploadsUploadFromScannerResponses, PostCoreUploadsUploadResponses, PostCoreWebhookDeliveriesRetryData, PostCoreWebhookDeliveriesRetryResponses, PostCoreWebhooksCreateData, PostCoreWebhooksCreateResponses, PostCoreWebhooksRotateSecretData, PostCoreWebhooksRotateSecretResponses, PostCoreWebhooksTestData, PostCoreWebhooksTestResponses, PostCoreWorkstationsCancelScanBarcodeData, PostCoreWorkstationsCancelScanBarcodeResponses, PostCoreWorkstationsScanBarcodeData, PostCoreWorkstationsScanBarcodeResponses, PostCrmConfigContactRelationshipTypesCreateData, PostCrmConfigContactRelationshipTypesCreateResponses, PostCrmConfigContactTypesCreateData, PostCrmConfigContactTypesCreateResponses, PostCrmConfigFileCategoriesCreateData, PostCrmConfigFileCategoriesCreateResponses, PostCrmContactFilesCreateData, PostCrmContactFilesCreateResponses, PostCrmContactNotesCreateData, PostCrmContactNotesCreateResponses, PostCrmContactRelationshipsCreateData, PostCrmContactRelationshipsCreateResponses, PostCrmContactsArchiveData, PostCrmContactsArchiveResponses, PostCrmContactsCreateData, PostCrmContactsCreateResponses, PostCrmContactsExportExportData, PostCrmContactsExportExportResponses, PostCrmContactsExportPreviewData, PostCrmContactsExportPreviewResponses, PostCrmContactsMergeData, PostCrmContactsMergeResponses, PostCrmContactsResolveByPhoneData, PostCrmContactsResolveByPhoneResponses, PostCrmContactsRestoreData, PostCrmContactsRestoreResponses, PostCrmContactsRevertMergeData, PostCrmContactsRevertMergeResponses, PostCrmHelpersParseAddressData, PostCrmHelpersParseAddressResponses, PostCrmPublicConfirmEmailVerifyData, PostCrmPublicConfirmEmailVerifyResponses, PostCrmPublicLookupZynoIdData, PostCrmPublicLookupZynoIdResponses, PostCrmPublicSendEmailVerifyData, PostCrmPublicSendEmailVerifyResponses, PostDisplayDeviceManagementDisableFirewallData, PostDisplayDeviceManagementDisableFirewallResponses, PostDisplayDeviceManagementExitData, PostDisplayDeviceManagementExitResponses, PostDisplayDeviceManagementFetchInstalledPackagesData, PostDisplayDeviceManagementFetchInstalledPackagesResponses, PostDisplayDeviceManagementInstallApkData, PostDisplayDeviceManagementInstallApkResponses, PostDisplayDeviceManagementLaunchApkData, PostDisplayDeviceManagementLaunchApkResponses, PostDisplayDeviceManagementLaunchIntentData, PostDisplayDeviceManagementLaunchIntentResponses, PostDisplayDeviceManagementLaunchSettingsData, PostDisplayDeviceManagementLaunchSettingsResponses, PostDisplayDeviceManagementLaunchWifiSettingsData, PostDisplayDeviceManagementLaunchWifiSettingsResponses, PostDisplayDeviceManagementRebootDeviceData, PostDisplayDeviceManagementRebootDeviceResponses, PostDisplayDeviceManagementRestartAppData, PostDisplayDeviceManagementRestartAppResponses, PostDisplayDeviceManagementRunCommandData, PostDisplayDeviceManagementRunCommandResponses, PostDisplayDeviceManagementSelfUpdateData, PostDisplayDeviceManagementSelfUpdateResponses, PostDisplayDeviceManagementSetDisplayOnData, PostDisplayDeviceManagementSetDisplayOnResponses, PostDisplayDeviceManagementSetDisplayPackageNameData, PostDisplayDeviceManagementSetDisplayPackageNameResponses, PostDisplayDeviceManagementSetLedColorData, PostDisplayDeviceManagementSetLedColorResponses, PostDisplayDeviceManagementUninstallApkData, PostDisplayDeviceManagementUninstallApkResponses, PostDisplayDevicesAddOutputScheduleData, PostDisplayDevicesAddOutputScheduleResponses, PostDisplayDevicesCreateOutputData, PostDisplayDevicesCreateOutputResponses, PostDisplayDevicesJumpToPlaylistItemData, PostDisplayDevicesJumpToPlaylistItemResponses, PostDisplayDevicesNextPlaylistItemData, PostDisplayDevicesNextPlaylistItemResponses, PostDisplayDevicesPrevPlaylistItemData, PostDisplayDevicesPrevPlaylistItemResponses, PostDisplayDevicesProbeContentUrlData, PostDisplayDevicesProbeContentUrlResponses, PostDisplayDevicesRegisterData, PostDisplayDevicesRegisterResponses, PostDisplayDevicesResetDisplayData, PostDisplayDevicesResetDisplayResponses, PostDisplayDevicesShowContentData, PostDisplayDevicesShowContentResponses, PostDisplayGroupsAddScheduleData, PostDisplayGroupsAddScheduleResponses, PostDisplayGroupsCreateData, PostDisplayGroupsCreateResponses, PostDisplayMediaCommitData, PostDisplayMediaCommitResponses, PostDisplayMediaCreateData, PostDisplayMediaCreateResponses, PostDisplayMediaSliceData, PostDisplayMediaSliceResponses, PostDisplayPlaylistsAddItemData, PostDisplayPlaylistsAddItemResponses, PostDisplayPlaylistsCreateData, PostDisplayPlaylistsCreateResponses, PostFormsManageCreateFormData, PostFormsManageCreateFormResponses, PostFormsManageDuplicateFormData, PostFormsManageDuplicateFormResponses, PostFormsManagePublishDefinitionData, PostFormsManagePublishDefinitionResponses, PostFormsManageSaveDefinitionData, PostFormsManageSaveDefinitionResponses, PostFormsPublicResolveZipData, PostFormsPublicResolveZipResponses, PostFormsPublicSubmitFormData, PostFormsPublicSubmitFormResponses, PostItFreshdeskBridgePublicGenerateSsoTokenData, PostItFreshdeskBridgePublicGenerateSsoTokenResponses, PostItFreshdeskBridgePublicSubmitFormData, PostItFreshdeskBridgePublicSubmitFormResponses, PostZynoRpcDispatchData, PostZynoRpcDispatchResponses, PutCoreConfigSetCommonConfigData, PutCoreConfigSetCommonConfigResponses, PutCoreLocationHoursSetLocationPolicyData, PutCoreLocationHoursSetLocationPolicyResponses, PutCoreLocationHoursSetManualData, PutCoreLocationHoursSetManualResponses, PutCoreLocationHoursSetSharedData, PutCoreLocationHoursSetSharedResponses, PutCoreLocationsUpdateData, PutCoreLocationsUpdateResponses, PutCoreTagsUpdateData, PutCoreTagsUpdateResponses, PutCoreWebhooksUpdateData, PutCoreWebhooksUpdateResponses, PutCoreWorkstationsUpdateData, PutCoreWorkstationsUpdateResponses, PutCrmCheckInsAckData, PutCrmCheckInsAckResponses, PutCrmConfigContactRelationshipTypesUpdateData, PutCrmConfigContactRelationshipTypesUpdateResponses, PutCrmConfigContactTypesUpdateData, PutCrmConfigContactTypesUpdateResponses, PutCrmConfigFileCategoriesUpdateData, PutCrmConfigFileCategoriesUpdateResponses, PutCrmContactFilesUpdateData, PutCrmContactFilesUpdateResponses, PutCrmContactNotesUpdateData, PutCrmContactNotesUpdateResponses, PutCrmContactRelationshipsUpdateData, PutCrmContactRelationshipsUpdateResponses, PutCrmContactsUpdateData, PutCrmContactsUpdateResponses, PutDisplayDevicesUpdateDeviceData, PutDisplayDevicesUpdateDeviceResponses, PutDisplayDevicesUpdateOutputData, PutDisplayDevicesUpdateOutputResponses, PutDisplayDevicesUpdateOutputScheduleData, PutDisplayDevicesUpdateOutputScheduleResponses, PutDisplayGroupsUpdateData, PutDisplayGroupsUpdateResponses, PutDisplayGroupsUpdateScheduleData, PutDisplayGroupsUpdateScheduleResponses, PutDisplayMediaUpdateData, PutDisplayMediaUpdateResponses, PutDisplayPlaylistsReorderData, PutDisplayPlaylistsReorderResponses, PutDisplayPlaylistsSetItemsData, PutDisplayPlaylistsSetItemsResponses, PutDisplayPlaylistsUpdateData, PutDisplayPlaylistsUpdateItemData, PutDisplayPlaylistsUpdateItemResponses, PutDisplayPlaylistsUpdateResponses, PutFormsManageUpdateFormData, PutFormsManageUpdateFormResponses, PutSystemAlertsAcknowledgeData, PutSystemAlertsAcknowledgeResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class SuiteZynoRpcApi {
    public static postZynoRpcDispatch<ThrowOnError extends boolean = false>(options: Options<PostZynoRpcDispatchData, ThrowOnError>): RequestResult<PostZynoRpcDispatchResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostZynoRpcDispatchResponses, unknown, ThrowOnError>({ url: '/zrpc/{svc}/{method}', ...options });
    }
}

export class SuiteCoreAuditApi {
    public static getCoreAuditIndex<ThrowOnError extends boolean = false>(options?: Options<GetCoreAuditIndexData, ThrowOnError>): RequestResult<GetCoreAuditIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreAuditIndexResponses, unknown, ThrowOnError>({ url: '/core/audit', ...options });
    }
}

export class SuiteCoreConfigApi {
    public static getCoreConfigGetConfigLegacy<ThrowOnError extends boolean = false>(options?: Options<GetCoreConfigGetConfigLegacyData, ThrowOnError>): RequestResult<GetCoreConfigGetConfigLegacyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreConfigGetConfigLegacyResponses, unknown, ThrowOnError>({ url: '/config/common', ...options });
    }
    
    public static putCoreConfigSetCommonConfig<ThrowOnError extends boolean = false>(options: Options<PutCoreConfigSetCommonConfigData, ThrowOnError>): RequestResult<PutCoreConfigSetCommonConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreConfigSetCommonConfigResponses, unknown, ThrowOnError>({
            url: '/config/common',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCoreConfigGetConsumerConfig<ThrowOnError extends boolean = false>(options?: Options<GetCoreConfigGetConsumerConfigData, ThrowOnError>): RequestResult<GetCoreConfigGetConsumerConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreConfigGetConsumerConfigResponses, unknown, ThrowOnError>({ url: '/config', ...options });
    }
}

export class SuiteCoreWorkstationsApi {
    public static getCoreWorkstationsList<ThrowOnError extends boolean = false>(options?: Options<GetCoreWorkstationsListData, ThrowOnError>): RequestResult<GetCoreWorkstationsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreWorkstationsListResponses, unknown, ThrowOnError>({ url: '/core/workstations', ...options });
    }
    
    public static putCoreWorkstationsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreWorkstationsUpdateData, ThrowOnError>): RequestResult<PutCoreWorkstationsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreWorkstationsUpdateResponses, unknown, ThrowOnError>({
            url: '/core/workstations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCoreWorkstationsScanBarcode<ThrowOnError extends boolean = false>(options?: Options<PostCoreWorkstationsScanBarcodeData, ThrowOnError>): RequestResult<PostCoreWorkstationsScanBarcodeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostCoreWorkstationsScanBarcodeResponses, unknown, ThrowOnError>({ url: '/core/workstations/self/scan-barcode', ...options });
    }
    
    public static postCoreWorkstationsCancelScanBarcode<ThrowOnError extends boolean = false>(options?: Options<PostCoreWorkstationsCancelScanBarcodeData, ThrowOnError>): RequestResult<PostCoreWorkstationsCancelScanBarcodeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostCoreWorkstationsCancelScanBarcodeResponses, unknown, ThrowOnError>({ url: '/core/workstations/self/cancel-scan-barcode', ...options });
    }
}

export class SuiteCoreLocationsApi {
    public static getCoreLocationsIndex<ThrowOnError extends boolean = false>(options?: Options<GetCoreLocationsIndexData, ThrowOnError>): RequestResult<GetCoreLocationsIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreLocationsIndexResponses, unknown, ThrowOnError>({ url: '/core/locations', ...options });
    }
    
    public static postCoreLocationsCreate<ThrowOnError extends boolean = false>(options: Options<PostCoreLocationsCreateData, ThrowOnError>): RequestResult<PostCoreLocationsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreLocationsCreateResponses, unknown, ThrowOnError>({
            url: '/core/locations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCoreLocationsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCoreLocationsDeleteData, ThrowOnError>): RequestResult<DeleteCoreLocationsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCoreLocationsDeleteResponses, unknown, ThrowOnError>({ url: '/core/locations/{id}', ...options });
    }
    
    public static putCoreLocationsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreLocationsUpdateData, ThrowOnError>): RequestResult<PutCoreLocationsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreLocationsUpdateResponses, unknown, ThrowOnError>({
            url: '/core/locations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCoreLocationHoursApi {
    public static getCoreLocationHoursIndex<ThrowOnError extends boolean = false>(options?: Options<GetCoreLocationHoursIndexData, ThrowOnError>): RequestResult<GetCoreLocationHoursIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreLocationHoursIndexResponses, unknown, ThrowOnError>({ url: '/core/location-hours', ...options });
    }
    
    public static getCoreLocationHoursShow<ThrowOnError extends boolean = false>(options: Options<GetCoreLocationHoursShowData, ThrowOnError>): RequestResult<GetCoreLocationHoursShowResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCoreLocationHoursShowResponses, unknown, ThrowOnError>({ url: '/core/location-hours/{locationId}', ...options });
    }
    
    public static putCoreLocationHoursSetShared<ThrowOnError extends boolean = false>(options: Options<PutCoreLocationHoursSetSharedData, ThrowOnError>): RequestResult<PutCoreLocationHoursSetSharedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreLocationHoursSetSharedResponses, unknown, ThrowOnError>({
            url: '/core/location-hours/shared',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putCoreLocationHoursSetLocationPolicy<ThrowOnError extends boolean = false>(options: Options<PutCoreLocationHoursSetLocationPolicyData, ThrowOnError>): RequestResult<PutCoreLocationHoursSetLocationPolicyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreLocationHoursSetLocationPolicyResponses, unknown, ThrowOnError>({
            url: '/core/location-hours/{locationId}/policy',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCoreLocationHoursUseShared<ThrowOnError extends boolean = false>(options: Options<PostCoreLocationHoursUseSharedData, ThrowOnError>): RequestResult<PostCoreLocationHoursUseSharedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreLocationHoursUseSharedResponses, unknown, ThrowOnError>({ url: '/core/location-hours/{locationId}/use-shared', ...options });
    }
    
    public static deleteCoreLocationHoursClearManual<ThrowOnError extends boolean = false>(options: Options<DeleteCoreLocationHoursClearManualData, ThrowOnError>): RequestResult<DeleteCoreLocationHoursClearManualResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCoreLocationHoursClearManualResponses, unknown, ThrowOnError>({ url: '/core/location-hours/{locationId}/manual', ...options });
    }
    
    public static putCoreLocationHoursSetManual<ThrowOnError extends boolean = false>(options: Options<PutCoreLocationHoursSetManualData, ThrowOnError>): RequestResult<PutCoreLocationHoursSetManualResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreLocationHoursSetManualResponses, unknown, ThrowOnError>({
            url: '/core/location-hours/{locationId}/manual',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCoreUploadsApi {
    public static postCoreUploadsUpload<ThrowOnError extends boolean = false>(options: Options<PostCoreUploadsUploadData, ThrowOnError>): RequestResult<PostCoreUploadsUploadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreUploadsUploadResponses, unknown, ThrowOnError>({
            url: '/core/uploads',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCoreUploadsUploadFromScanner<ThrowOnError extends boolean = false>(options: Options<PostCoreUploadsUploadFromScannerData, ThrowOnError>): RequestResult<PostCoreUploadsUploadFromScannerResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreUploadsUploadFromScannerResponses, unknown, ThrowOnError>({
            url: '/core/uploads/from-scanner',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCoreEtlApi {
    public static postCoreEtlExport<ThrowOnError extends boolean = false>(options?: Options<PostCoreEtlExportData, ThrowOnError>): RequestResult<PostCoreEtlExportResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostCoreEtlExportResponses, unknown, ThrowOnError>({ url: '/core/etl/export', ...options });
    }
    
    public static postCoreEtlImport<ThrowOnError extends boolean = false>(options?: Options<PostCoreEtlImportData, ThrowOnError>): RequestResult<PostCoreEtlImportResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostCoreEtlImportResponses, unknown, ThrowOnError>({ url: '/core/etl/import', ...options });
    }
}

export class SuiteCoreTagsApi {
    public static getCoreTagsIndex<ThrowOnError extends boolean = false>(options: Options<GetCoreTagsIndexData, ThrowOnError>): RequestResult<GetCoreTagsIndexResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCoreTagsIndexResponses, unknown, ThrowOnError>({ url: '/tags/{module}', ...options });
    }
    
    public static postCoreTagsCreate<ThrowOnError extends boolean = false>(options: Options<PostCoreTagsCreateData, ThrowOnError>): RequestResult<PostCoreTagsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreTagsCreateResponses, unknown, ThrowOnError>({
            url: '/tags/{module}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCoreTagsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCoreTagsDeleteData, ThrowOnError>): RequestResult<DeleteCoreTagsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCoreTagsDeleteResponses, unknown, ThrowOnError>({ url: '/tags/{module}/{id}', ...options });
    }
    
    public static putCoreTagsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreTagsUpdateData, ThrowOnError>): RequestResult<PutCoreTagsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreTagsUpdateResponses, unknown, ThrowOnError>({
            url: '/tags/{module}/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteSystemAlertsApi {
    public static getSystemAlertsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSystemAlertsIndexData, ThrowOnError>): RequestResult<GetSystemAlertsIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSystemAlertsIndexResponses, unknown, ThrowOnError>({ url: '/system/alerts', ...options });
    }
    
    public static putSystemAlertsAcknowledge<ThrowOnError extends boolean = false>(options: Options<PutSystemAlertsAcknowledgeData, ThrowOnError>): RequestResult<PutSystemAlertsAcknowledgeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSystemAlertsAcknowledgeResponses, unknown, ThrowOnError>({ url: '/system/alerts/{id}/ack', ...options });
    }
}

export class SuiteCoreWebhooksApi {
    public static getCoreWebhooksEventTypes<ThrowOnError extends boolean = false>(options?: Options<GetCoreWebhooksEventTypesData, ThrowOnError>): RequestResult<GetCoreWebhooksEventTypesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreWebhooksEventTypesResponses, unknown, ThrowOnError>({ url: '/core/webhooks/event-types', ...options });
    }
    
    public static getCoreWebhooksIndex<ThrowOnError extends boolean = false>(options?: Options<GetCoreWebhooksIndexData, ThrowOnError>): RequestResult<GetCoreWebhooksIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCoreWebhooksIndexResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints', ...options });
    }
    
    public static postCoreWebhooksCreate<ThrowOnError extends boolean = false>(options: Options<PostCoreWebhooksCreateData, ThrowOnError>): RequestResult<PostCoreWebhooksCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreWebhooksCreateResponses, unknown, ThrowOnError>({
            url: '/core/webhooks/endpoints',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCoreWebhooksDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCoreWebhooksDeleteData, ThrowOnError>): RequestResult<DeleteCoreWebhooksDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCoreWebhooksDeleteResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints/{id}', ...options });
    }
    
    public static getCoreWebhooksShow<ThrowOnError extends boolean = false>(options: Options<GetCoreWebhooksShowData, ThrowOnError>): RequestResult<GetCoreWebhooksShowResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCoreWebhooksShowResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints/{id}', ...options });
    }
    
    public static putCoreWebhooksUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreWebhooksUpdateData, ThrowOnError>): RequestResult<PutCoreWebhooksUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCoreWebhooksUpdateResponses, unknown, ThrowOnError>({
            url: '/core/webhooks/endpoints/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCoreWebhooksRotateSecret<ThrowOnError extends boolean = false>(options: Options<PostCoreWebhooksRotateSecretData, ThrowOnError>): RequestResult<PostCoreWebhooksRotateSecretResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreWebhooksRotateSecretResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints/{id}/rotate-secret', ...options });
    }
    
    public static postCoreWebhooksTest<ThrowOnError extends boolean = false>(options: Options<PostCoreWebhooksTestData, ThrowOnError>): RequestResult<PostCoreWebhooksTestResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreWebhooksTestResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints/{id}/test', ...options });
    }
    
    public static getCoreWebhooksDeliveries<ThrowOnError extends boolean = false>(options: Options<GetCoreWebhooksDeliveriesData, ThrowOnError>): RequestResult<GetCoreWebhooksDeliveriesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCoreWebhooksDeliveriesResponses, unknown, ThrowOnError>({ url: '/core/webhooks/endpoints/{id}/deliveries', ...options });
    }
}

export class SuiteCoreWebhookDeliveriesApi {
    public static getCoreWebhookDeliveriesShow<ThrowOnError extends boolean = false>(options: Options<GetCoreWebhookDeliveriesShowData, ThrowOnError>): RequestResult<GetCoreWebhookDeliveriesShowResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCoreWebhookDeliveriesShowResponses, unknown, ThrowOnError>({ url: '/core/webhooks/deliveries/{id}', ...options });
    }
    
    public static postCoreWebhookDeliveriesRetry<ThrowOnError extends boolean = false>(options: Options<PostCoreWebhookDeliveriesRetryData, ThrowOnError>): RequestResult<PostCoreWebhookDeliveriesRetryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCoreWebhookDeliveriesRetryResponses, unknown, ThrowOnError>({ url: '/core/webhooks/deliveries/{id}/retry', ...options });
    }
}

export class SuiteCrmCheckInsApi {
    public static getCrmCheckInsList<ThrowOnError extends boolean = false>(options?: Options<GetCrmCheckInsListData, ThrowOnError>): RequestResult<GetCrmCheckInsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCrmCheckInsListResponses, unknown, ThrowOnError>({ url: '/crm/check-ins', ...options });
    }
    
    public static putCrmCheckInsAck<ThrowOnError extends boolean = false>(options: Options<PutCrmCheckInsAckData, ThrowOnError>): RequestResult<PutCrmCheckInsAckResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmCheckInsAckResponses, unknown, ThrowOnError>({ url: '/crm/check-ins/{id}/ack', ...options });
    }
}

export class SuiteCrmConfigContactRelationshipTypesApi {
    public static getCrmConfigContactRelationshipTypesIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmConfigContactRelationshipTypesIndexData, ThrowOnError>): RequestResult<GetCrmConfigContactRelationshipTypesIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCrmConfigContactRelationshipTypesIndexResponses, unknown, ThrowOnError>({ url: '/crm/config/contact-relationship-types', ...options });
    }
    
    public static postCrmConfigContactRelationshipTypesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmConfigContactRelationshipTypesCreateData, ThrowOnError>): RequestResult<PostCrmConfigContactRelationshipTypesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmConfigContactRelationshipTypesCreateResponses, unknown, ThrowOnError>({
            url: '/crm/config/contact-relationship-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCrmConfigContactRelationshipTypesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmConfigContactRelationshipTypesDeleteData, ThrowOnError>): RequestResult<DeleteCrmConfigContactRelationshipTypesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmConfigContactRelationshipTypesDeleteResponses, unknown, ThrowOnError>({ url: '/crm/config/contact-relationship-types/{id}', ...options });
    }
    
    public static putCrmConfigContactRelationshipTypesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmConfigContactRelationshipTypesUpdateData, ThrowOnError>): RequestResult<PutCrmConfigContactRelationshipTypesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmConfigContactRelationshipTypesUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/config/contact-relationship-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmConfigContactTypesApi {
    public static getCrmConfigContactTypesIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmConfigContactTypesIndexData, ThrowOnError>): RequestResult<GetCrmConfigContactTypesIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCrmConfigContactTypesIndexResponses, unknown, ThrowOnError>({ url: '/crm/config/contact-types', ...options });
    }
    
    public static postCrmConfigContactTypesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmConfigContactTypesCreateData, ThrowOnError>): RequestResult<PostCrmConfigContactTypesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmConfigContactTypesCreateResponses, unknown, ThrowOnError>({
            url: '/crm/config/contact-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCrmConfigContactTypesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmConfigContactTypesDeleteData, ThrowOnError>): RequestResult<DeleteCrmConfigContactTypesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmConfigContactTypesDeleteResponses, unknown, ThrowOnError>({ url: '/crm/config/contact-types/{id}', ...options });
    }
    
    public static putCrmConfigContactTypesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmConfigContactTypesUpdateData, ThrowOnError>): RequestResult<PutCrmConfigContactTypesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmConfigContactTypesUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/config/contact-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmConfigFileCategoriesApi {
    public static getCrmConfigFileCategoriesIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmConfigFileCategoriesIndexData, ThrowOnError>): RequestResult<GetCrmConfigFileCategoriesIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCrmConfigFileCategoriesIndexResponses, unknown, ThrowOnError>({ url: '/crm/config/file-categories', ...options });
    }
    
    public static postCrmConfigFileCategoriesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmConfigFileCategoriesCreateData, ThrowOnError>): RequestResult<PostCrmConfigFileCategoriesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmConfigFileCategoriesCreateResponses, unknown, ThrowOnError>({
            url: '/crm/config/file-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCrmConfigFileCategoriesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmConfigFileCategoriesDeleteData, ThrowOnError>): RequestResult<DeleteCrmConfigFileCategoriesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmConfigFileCategoriesDeleteResponses, unknown, ThrowOnError>({ url: '/crm/config/file-categories/{id}', ...options });
    }
    
    public static putCrmConfigFileCategoriesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmConfigFileCategoriesUpdateData, ThrowOnError>): RequestResult<PutCrmConfigFileCategoriesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmConfigFileCategoriesUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/config/file-categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmContactsApi {
    public static getCrmContactsIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmContactsIndexData, ThrowOnError>): RequestResult<GetCrmContactsIndexResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCrmContactsIndexResponses, unknown, ThrowOnError>({ url: '/crm/contacts', ...options });
    }
    
    public static postCrmContactsCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsCreateData, ThrowOnError>): RequestResult<PostCrmContactsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsCreateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Bulk-resolve a list of phone numbers to the contacts that own them. Strict exact match: inputs are assumed to already be E.164 (which is what we store), so no normalization is applied — a non-E.164 input simply matches nothing. Backed by the (tenantId, phone) index on crm_contacts_phones for high-speed lookups.
     */
    public static postCrmContactsResolveByPhone<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsResolveByPhoneData, ThrowOnError>): RequestResult<PostCrmContactsResolveByPhoneResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsResolveByPhoneResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/resolve-by-phone',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCrmContactsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactsDeleteData, ThrowOnError>): RequestResult<DeleteCrmContactsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmContactsDeleteResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{id}', ...options });
    }
    
    public static getCrmContactsShow<ThrowOnError extends boolean = false>(options: Options<GetCrmContactsShowData, ThrowOnError>): RequestResult<GetCrmContactsShowResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactsShowResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{id}', ...options });
    }
    
    public static putCrmContactsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactsUpdateData, ThrowOnError>): RequestResult<PutCrmContactsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmContactsUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Merge one or more source contacts into this (target/survivor) contact. Each source is applied as an independent, individually-revertible 1:1 merge. See CrmContactMergeService.
     */
    public static postCrmContactsMerge<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsMergeData, ThrowOnError>): RequestResult<PostCrmContactsMergeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsMergeResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{targetId}/merge',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revert a previously-applied merge, restoring the source contact and its remapped data.
     */
    public static postCrmContactsRevertMerge<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsRevertMergeData, ThrowOnError>): RequestResult<PostCrmContactsRevertMergeResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsRevertMergeResponses, unknown, ThrowOnError>({ url: '/crm/contacts/merges/{mergeId}/revert', ...options });
    }
    
    public static postCrmContactsArchive<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsArchiveData, ThrowOnError>): RequestResult<PostCrmContactsArchiveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsArchiveResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{id}/archive', ...options });
    }
    
    public static postCrmContactsRestore<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsRestoreData, ThrowOnError>): RequestResult<PostCrmContactsRestoreResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsRestoreResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{id}/restore', ...options });
    }
}

export class SuiteCrmContactRelationshipsApi {
    public static getCrmContactRelationshipsIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactRelationshipsIndexData, ThrowOnError>): RequestResult<GetCrmContactRelationshipsIndexResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactRelationshipsIndexResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/relationships', ...options });
    }
    
    public static postCrmContactRelationshipsCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactRelationshipsCreateData, ThrowOnError>): RequestResult<PostCrmContactRelationshipsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactRelationshipsCreateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/relationships',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteCrmContactRelationshipsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactRelationshipsDeleteData, ThrowOnError>): RequestResult<DeleteCrmContactRelationshipsDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmContactRelationshipsDeleteResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/relationships/{relationshipId}', ...options });
    }
    
    public static putCrmContactRelationshipsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactRelationshipsUpdateData, ThrowOnError>): RequestResult<PutCrmContactRelationshipsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmContactRelationshipsUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/relationships/{relationshipId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmContactsExportApi {
    public static postCrmContactsExportPreview<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsExportPreviewData, ThrowOnError>): RequestResult<PostCrmContactsExportPreviewResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsExportPreviewResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/export/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCrmContactsExportExport<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsExportExportData, ThrowOnError>): RequestResult<PostCrmContactsExportExportResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactsExportExportResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/export',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmContactNotesApi {
    public static getCrmContactNotesIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactNotesIndexData, ThrowOnError>): RequestResult<GetCrmContactNotesIndexResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactNotesIndexResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/notes', ...options });
    }
    
    public static postCrmContactNotesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactNotesCreateData, ThrowOnError>): RequestResult<PostCrmContactNotesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactNotesCreateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCrmContactNotesHistory<ThrowOnError extends boolean = false>(options: Options<GetCrmContactNotesHistoryData, ThrowOnError>): RequestResult<GetCrmContactNotesHistoryResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactNotesHistoryResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/notes/{id}/history', ...options });
    }
    
    public static deleteCrmContactNotesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactNotesDeleteData, ThrowOnError>): RequestResult<DeleteCrmContactNotesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmContactNotesDeleteResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/notes/{id}', ...options });
    }
    
    public static putCrmContactNotesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactNotesUpdateData, ThrowOnError>): RequestResult<PutCrmContactNotesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmContactNotesUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmContactFilesApi {
    public static getCrmContactFilesIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactFilesIndexData, ThrowOnError>): RequestResult<GetCrmContactFilesIndexResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactFilesIndexResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/files', ...options });
    }
    
    public static postCrmContactFilesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactFilesCreateData, ThrowOnError>): RequestResult<PostCrmContactFilesCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmContactFilesCreateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getCrmContactFilesDownload<ThrowOnError extends boolean = false>(options: Options<GetCrmContactFilesDownloadData, ThrowOnError>): RequestResult<GetCrmContactFilesDownloadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCrmContactFilesDownloadResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/files/{id}/download', ...options });
    }
    
    public static deleteCrmContactFilesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactFilesDeleteData, ThrowOnError>): RequestResult<DeleteCrmContactFilesDeleteResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteCrmContactFilesDeleteResponses, unknown, ThrowOnError>({ url: '/crm/contacts/{contactId}/files/{id}', ...options });
    }
    
    public static putCrmContactFilesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactFilesUpdateData, ThrowOnError>): RequestResult<PutCrmContactFilesUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutCrmContactFilesUpdateResponses, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmHelpersApi {
    public static postCrmHelpersParseAddress<ThrowOnError extends boolean = false>(options: Options<PostCrmHelpersParseAddressData, ThrowOnError>): RequestResult<PostCrmHelpersParseAddressResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmHelpersParseAddressResponses, unknown, ThrowOnError>({
            url: '/crm/helpers/parse-address',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteCrmPublicApi {
    public static postCrmPublicSendEmailVerify<ThrowOnError extends boolean = false>(options: Options<PostCrmPublicSendEmailVerifyData, ThrowOnError>): RequestResult<PostCrmPublicSendEmailVerifyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmPublicSendEmailVerifyResponses, unknown, ThrowOnError>({
            url: '/public/crm/send-email-verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCrmPublicConfirmEmailVerify<ThrowOnError extends boolean = false>(options: Options<PostCrmPublicConfirmEmailVerifyData, ThrowOnError>): RequestResult<PostCrmPublicConfirmEmailVerifyResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmPublicConfirmEmailVerifyResponses, unknown, ThrowOnError>({
            url: '/public/crm/confirm-email-verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postCrmPublicLookupZynoId<ThrowOnError extends boolean = false>(options: Options<PostCrmPublicLookupZynoIdData, ThrowOnError>): RequestResult<PostCrmPublicLookupZynoIdResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCrmPublicLookupZynoIdResponses, unknown, ThrowOnError>({
            url: '/public/crm/lookup-zyno-id',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteDisplayDevicesApi {
    public static getDisplayDevicesList<ThrowOnError extends boolean = false>(options?: Options<GetDisplayDevicesListData, ThrowOnError>): RequestResult<GetDisplayDevicesListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDisplayDevicesListResponses, unknown, ThrowOnError>({ url: '/display/devices', ...options });
    }
    
    public static postDisplayDevicesRegister<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesRegisterData, ThrowOnError>): RequestResult<PostDisplayDevicesRegisterResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesRegisterResponses, unknown, ThrowOnError>({
            url: '/display/devices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayDevicesDeleteDevice<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayDevicesDeleteDeviceData, ThrowOnError>): RequestResult<DeleteDisplayDevicesDeleteDeviceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayDevicesDeleteDeviceResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}', ...options });
    }
    
    public static getDisplayDevicesGet<ThrowOnError extends boolean = false>(options: Options<GetDisplayDevicesGetData, ThrowOnError>): RequestResult<GetDisplayDevicesGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDisplayDevicesGetResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}', ...options });
    }
    
    public static putDisplayDevicesUpdateDevice<ThrowOnError extends boolean = false>(options: Options<PutDisplayDevicesUpdateDeviceData, ThrowOnError>): RequestResult<PutDisplayDevicesUpdateDeviceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayDevicesUpdateDeviceResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesCreateOutput<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesCreateOutputData, ThrowOnError>): RequestResult<PostDisplayDevicesCreateOutputResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesCreateOutputResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/outputs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayDevicesDeleteOutput<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayDevicesDeleteOutputData, ThrowOnError>): RequestResult<DeleteDisplayDevicesDeleteOutputResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayDevicesDeleteOutputResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/outputs/{outputId}', ...options });
    }
    
    public static putDisplayDevicesUpdateOutput<ThrowOnError extends boolean = false>(options: Options<PutDisplayDevicesUpdateOutputData, ThrowOnError>): RequestResult<PutDisplayDevicesUpdateOutputResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayDevicesUpdateOutputResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/outputs/{outputId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesAddOutputSchedule<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesAddOutputScheduleData, ThrowOnError>): RequestResult<PostDisplayDevicesAddOutputScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesAddOutputScheduleResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/outputs/{outputId}/schedules',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayDevicesRemoveOutputSchedule<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayDevicesRemoveOutputScheduleData, ThrowOnError>): RequestResult<DeleteDisplayDevicesRemoveOutputScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayDevicesRemoveOutputScheduleResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/outputs/{outputId}/schedules/{scheduleId}', ...options });
    }
    
    public static putDisplayDevicesUpdateOutputSchedule<ThrowOnError extends boolean = false>(options: Options<PutDisplayDevicesUpdateOutputScheduleData, ThrowOnError>): RequestResult<PutDisplayDevicesUpdateOutputScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayDevicesUpdateOutputScheduleResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/outputs/{outputId}/schedules/{scheduleId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesShowContent<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesShowContentData, ThrowOnError>): RequestResult<PostDisplayDevicesShowContentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesShowContentResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/show-content',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesProbeContentUrl<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesProbeContentUrlData, ThrowOnError>): RequestResult<PostDisplayDevicesProbeContentUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesProbeContentUrlResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/probe-content-url',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesResetDisplay<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesResetDisplayData, ThrowOnError>): RequestResult<PostDisplayDevicesResetDisplayResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesResetDisplayResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/reset-display',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesNextPlaylistItem<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesNextPlaylistItemData, ThrowOnError>): RequestResult<PostDisplayDevicesNextPlaylistItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesNextPlaylistItemResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/next-playlist-item',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesPrevPlaylistItem<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesPrevPlaylistItemData, ThrowOnError>): RequestResult<PostDisplayDevicesPrevPlaylistItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesPrevPlaylistItemResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/prev-playlist-item',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDevicesJumpToPlaylistItem<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesJumpToPlaylistItemData, ThrowOnError>): RequestResult<PostDisplayDevicesJumpToPlaylistItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDevicesJumpToPlaylistItemResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/jump-to-playlist-item',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteDisplayDeviceManagementApi {
    public static postDisplayDeviceManagementInstallApk<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementInstallApkData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementInstallApkResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementInstallApkResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/install-apk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementUninstallApk<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementUninstallApkData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementUninstallApkResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementUninstallApkResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/uninstall-apk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementLaunchApk<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementLaunchApkData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementLaunchApkResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementLaunchApkResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/launch-apk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementSelfUpdate<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementSelfUpdateData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementSelfUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementSelfUpdateResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/self-update', ...options });
    }
    
    public static postDisplayDeviceManagementSetDisplayPackageName<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementSetDisplayPackageNameData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementSetDisplayPackageNameResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementSetDisplayPackageNameResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/set-display-package-name',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementSetDisplayOn<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementSetDisplayOnData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementSetDisplayOnResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementSetDisplayOnResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/set-display-on',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementRebootDevice<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementRebootDeviceData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementRebootDeviceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementRebootDeviceResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/reboot-device',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementRestartApp<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementRestartAppData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementRestartAppResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementRestartAppResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/restart-app', ...options });
    }
    
    public static postDisplayDeviceManagementExit<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementExitData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementExitResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementExitResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/exit', ...options });
    }
    
    public static postDisplayDeviceManagementFetchInstalledPackages<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementFetchInstalledPackagesData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementFetchInstalledPackagesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementFetchInstalledPackagesResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/fetch-installed-packages', ...options });
    }
    
    public static postDisplayDeviceManagementSetLedColor<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementSetLedColorData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementSetLedColorResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementSetLedColorResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/set-led-color',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementRunCommand<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementRunCommandData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementRunCommandResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementRunCommandResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/run-command',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementLaunchIntent<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementLaunchIntentData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementLaunchIntentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementLaunchIntentResponses, unknown, ThrowOnError>({
            url: '/display/devices/{id}/dm/launch-intent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayDeviceManagementLaunchSettings<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementLaunchSettingsData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementLaunchSettingsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementLaunchSettingsResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/launch-settings', ...options });
    }
    
    public static postDisplayDeviceManagementLaunchWifiSettings<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementLaunchWifiSettingsData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementLaunchWifiSettingsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementLaunchWifiSettingsResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/launch-wifi-settings', ...options });
    }
    
    public static postDisplayDeviceManagementDisableFirewall<ThrowOnError extends boolean = false>(options: Options<PostDisplayDeviceManagementDisableFirewallData, ThrowOnError>): RequestResult<PostDisplayDeviceManagementDisableFirewallResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayDeviceManagementDisableFirewallResponses, unknown, ThrowOnError>({ url: '/display/devices/{id}/dm/disable-firewall', ...options });
    }
}

export class SuiteDisplayMediaApi {
    public static getDisplayMediaList<ThrowOnError extends boolean = false>(options?: Options<GetDisplayMediaListData, ThrowOnError>): RequestResult<GetDisplayMediaListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDisplayMediaListResponses, unknown, ThrowOnError>({ url: '/display/media', ...options });
    }
    
    public static postDisplayMediaCreate<ThrowOnError extends boolean = false>(options: Options<PostDisplayMediaCreateData, ThrowOnError>): RequestResult<PostDisplayMediaCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayMediaCreateResponses, unknown, ThrowOnError>({
            url: '/display/media',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayMediaCommit<ThrowOnError extends boolean = false>(options: Options<PostDisplayMediaCommitData, ThrowOnError>): RequestResult<PostDisplayMediaCommitResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayMediaCommitResponses, unknown, ThrowOnError>({ url: '/display/media/{id}/commit', ...options });
    }
    
    public static postDisplayMediaSlice<ThrowOnError extends boolean = false>(options: Options<PostDisplayMediaSliceData, ThrowOnError>): RequestResult<PostDisplayMediaSliceResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayMediaSliceResponses, unknown, ThrowOnError>({
            url: '/display/media/slice',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayMediaRemove<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayMediaRemoveData, ThrowOnError>): RequestResult<DeleteDisplayMediaRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayMediaRemoveResponses, unknown, ThrowOnError>({ url: '/display/media/{id}', ...options });
    }
    
    public static putDisplayMediaUpdate<ThrowOnError extends boolean = false>(options: Options<PutDisplayMediaUpdateData, ThrowOnError>): RequestResult<PutDisplayMediaUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayMediaUpdateResponses, unknown, ThrowOnError>({
            url: '/display/media/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteDisplayMediaPublicApi {
    public static getDisplayMediaPublicRedirect<ThrowOnError extends boolean = false>(options: Options<GetDisplayMediaPublicRedirectData, ThrowOnError>): RequestResult<GetDisplayMediaPublicRedirectResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDisplayMediaPublicRedirectResponses, unknown, ThrowOnError>({ url: '/public/display/media/{id}/r/{rendition}', ...options });
    }
    
    /**
     * HEAD probe: same auth/readiness/variant resolution as the GET, but instead of a 302 we answer 200 with the delivered object's `Content-Type` and the signed storage URL in `Location`. Lets a client learn the media type and the real URL in one round trip without following the redirect or downloading the body.
     */
    public static headDisplayMediaPublicHead<ThrowOnError extends boolean = false>(options: Options<HeadDisplayMediaPublicHeadData, ThrowOnError>): RequestResult<HeadDisplayMediaPublicHeadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).head<HeadDisplayMediaPublicHeadResponses, unknown, ThrowOnError>({ url: '/public/display/media/{id}/r/{rendition}', ...options });
    }
}

export class SuiteDisplayPlaylistsApi {
    public static getDisplayPlaylistsList<ThrowOnError extends boolean = false>(options?: Options<GetDisplayPlaylistsListData, ThrowOnError>): RequestResult<GetDisplayPlaylistsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDisplayPlaylistsListResponses, unknown, ThrowOnError>({ url: '/display/playlists', ...options });
    }
    
    public static postDisplayPlaylistsCreate<ThrowOnError extends boolean = false>(options: Options<PostDisplayPlaylistsCreateData, ThrowOnError>): RequestResult<PostDisplayPlaylistsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayPlaylistsCreateResponses, unknown, ThrowOnError>({
            url: '/display/playlists',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayPlaylistsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayPlaylistsRemoveData, ThrowOnError>): RequestResult<DeleteDisplayPlaylistsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayPlaylistsRemoveResponses, unknown, ThrowOnError>({ url: '/display/playlists/{id}', ...options });
    }
    
    public static getDisplayPlaylistsGet<ThrowOnError extends boolean = false>(options: Options<GetDisplayPlaylistsGetData, ThrowOnError>): RequestResult<GetDisplayPlaylistsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDisplayPlaylistsGetResponses, unknown, ThrowOnError>({ url: '/display/playlists/{id}', ...options });
    }
    
    public static putDisplayPlaylistsUpdate<ThrowOnError extends boolean = false>(options: Options<PutDisplayPlaylistsUpdateData, ThrowOnError>): RequestResult<PutDisplayPlaylistsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayPlaylistsUpdateResponses, unknown, ThrowOnError>({
            url: '/display/playlists/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayPlaylistsAddItem<ThrowOnError extends boolean = false>(options: Options<PostDisplayPlaylistsAddItemData, ThrowOnError>): RequestResult<PostDisplayPlaylistsAddItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayPlaylistsAddItemResponses, unknown, ThrowOnError>({
            url: '/display/playlists/{id}/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDisplayPlaylistsSetItems<ThrowOnError extends boolean = false>(options: Options<PutDisplayPlaylistsSetItemsData, ThrowOnError>): RequestResult<PutDisplayPlaylistsSetItemsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayPlaylistsSetItemsResponses, unknown, ThrowOnError>({
            url: '/display/playlists/{id}/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDisplayPlaylistsReorder<ThrowOnError extends boolean = false>(options: Options<PutDisplayPlaylistsReorderData, ThrowOnError>): RequestResult<PutDisplayPlaylistsReorderResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayPlaylistsReorderResponses, unknown, ThrowOnError>({
            url: '/display/playlists/{id}/items/reorder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayPlaylistsRemoveItem<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayPlaylistsRemoveItemData, ThrowOnError>): RequestResult<DeleteDisplayPlaylistsRemoveItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayPlaylistsRemoveItemResponses, unknown, ThrowOnError>({ url: '/display/playlists/{id}/items/{itemId}', ...options });
    }
    
    public static putDisplayPlaylistsUpdateItem<ThrowOnError extends boolean = false>(options: Options<PutDisplayPlaylistsUpdateItemData, ThrowOnError>): RequestResult<PutDisplayPlaylistsUpdateItemResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayPlaylistsUpdateItemResponses, unknown, ThrowOnError>({
            url: '/display/playlists/{id}/items/{itemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteDisplayGroupsApi {
    public static getDisplayGroupsList<ThrowOnError extends boolean = false>(options?: Options<GetDisplayGroupsListData, ThrowOnError>): RequestResult<GetDisplayGroupsListResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDisplayGroupsListResponses, unknown, ThrowOnError>({ url: '/display/groups', ...options });
    }
    
    public static postDisplayGroupsCreate<ThrowOnError extends boolean = false>(options: Options<PostDisplayGroupsCreateData, ThrowOnError>): RequestResult<PostDisplayGroupsCreateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayGroupsCreateResponses, unknown, ThrowOnError>({
            url: '/display/groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayGroupsRemove<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayGroupsRemoveData, ThrowOnError>): RequestResult<DeleteDisplayGroupsRemoveResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayGroupsRemoveResponses, unknown, ThrowOnError>({ url: '/display/groups/{id}', ...options });
    }
    
    public static getDisplayGroupsGet<ThrowOnError extends boolean = false>(options: Options<GetDisplayGroupsGetData, ThrowOnError>): RequestResult<GetDisplayGroupsGetResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDisplayGroupsGetResponses, unknown, ThrowOnError>({ url: '/display/groups/{id}', ...options });
    }
    
    public static putDisplayGroupsUpdate<ThrowOnError extends boolean = false>(options: Options<PutDisplayGroupsUpdateData, ThrowOnError>): RequestResult<PutDisplayGroupsUpdateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayGroupsUpdateResponses, unknown, ThrowOnError>({
            url: '/display/groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDisplayGroupsAddSchedule<ThrowOnError extends boolean = false>(options: Options<PostDisplayGroupsAddScheduleData, ThrowOnError>): RequestResult<PostDisplayGroupsAddScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDisplayGroupsAddScheduleResponses, unknown, ThrowOnError>({
            url: '/display/groups/{id}/schedules',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteDisplayGroupsRemoveSchedule<ThrowOnError extends boolean = false>(options: Options<DeleteDisplayGroupsRemoveScheduleData, ThrowOnError>): RequestResult<DeleteDisplayGroupsRemoveScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDisplayGroupsRemoveScheduleResponses, unknown, ThrowOnError>({ url: '/display/groups/{id}/schedules/{scheduleId}', ...options });
    }
    
    public static putDisplayGroupsUpdateSchedule<ThrowOnError extends boolean = false>(options: Options<PutDisplayGroupsUpdateScheduleData, ThrowOnError>): RequestResult<PutDisplayGroupsUpdateScheduleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDisplayGroupsUpdateScheduleResponses, unknown, ThrowOnError>({
            url: '/display/groups/{id}/schedules/{scheduleId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteFormsApi {
    public static getFormsListForms<ThrowOnError extends boolean = false>(options?: Options<GetFormsListFormsData, ThrowOnError>): RequestResult<GetFormsListFormsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetFormsListFormsResponses, unknown, ThrowOnError>({ url: '/forms', ...options });
    }
}

export class SuiteFormsManageApi {
    public static postFormsManageCreateForm<ThrowOnError extends boolean = false>(options: Options<PostFormsManageCreateFormData, ThrowOnError>): RequestResult<PostFormsManageCreateFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsManageCreateFormResponses, unknown, ThrowOnError>({
            url: '/forms/manage',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteFormsManageDeleteForm<ThrowOnError extends boolean = false>(options: Options<DeleteFormsManageDeleteFormData, ThrowOnError>): RequestResult<DeleteFormsManageDeleteFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteFormsManageDeleteFormResponses, unknown, ThrowOnError>({ url: '/forms/manage/{id}', ...options });
    }
    
    public static getFormsManageGetForm<ThrowOnError extends boolean = false>(options: Options<GetFormsManageGetFormData, ThrowOnError>): RequestResult<GetFormsManageGetFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormsManageGetFormResponses, unknown, ThrowOnError>({ url: '/forms/manage/{id}', ...options });
    }
    
    public static putFormsManageUpdateForm<ThrowOnError extends boolean = false>(options: Options<PutFormsManageUpdateFormData, ThrowOnError>): RequestResult<PutFormsManageUpdateFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutFormsManageUpdateFormResponses, unknown, ThrowOnError>({
            url: '/forms/manage/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postFormsManageDuplicateForm<ThrowOnError extends boolean = false>(options: Options<PostFormsManageDuplicateFormData, ThrowOnError>): RequestResult<PostFormsManageDuplicateFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsManageDuplicateFormResponses, unknown, ThrowOnError>({
            url: '/forms/manage/{id}/duplicate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getFormsManageListDefinitions<ThrowOnError extends boolean = false>(options: Options<GetFormsManageListDefinitionsData, ThrowOnError>): RequestResult<GetFormsManageListDefinitionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormsManageListDefinitionsResponses, unknown, ThrowOnError>({ url: '/forms/manage/{id}/definitions', ...options });
    }
    
    /**
     * Upserts the form's single draft, optionally publishing it in the same call.
     */
    public static postFormsManageSaveDefinition<ThrowOnError extends boolean = false>(options: Options<PostFormsManageSaveDefinitionData, ThrowOnError>): RequestResult<PostFormsManageSaveDefinitionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsManageSaveDefinitionResponses, unknown, ThrowOnError>({
            url: '/forms/manage/{id}/definitions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteFormsManageDiscardDraft<ThrowOnError extends boolean = false>(options: Options<DeleteFormsManageDiscardDraftData, ThrowOnError>): RequestResult<DeleteFormsManageDiscardDraftResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteFormsManageDiscardDraftResponses, unknown, ThrowOnError>({ url: '/forms/manage/{id}/definitions/{definitionId}', ...options });
    }
    
    public static getFormsManageGetDefinition<ThrowOnError extends boolean = false>(options: Options<GetFormsManageGetDefinitionData, ThrowOnError>): RequestResult<GetFormsManageGetDefinitionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormsManageGetDefinitionResponses, unknown, ThrowOnError>({ url: '/forms/manage/{id}/definitions/{definitionId}', ...options });
    }
    
    public static postFormsManagePublishDefinition<ThrowOnError extends boolean = false>(options: Options<PostFormsManagePublishDefinitionData, ThrowOnError>): RequestResult<PostFormsManagePublishDefinitionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsManagePublishDefinitionResponses, unknown, ThrowOnError>({
            url: '/forms/manage/{id}/definitions/{definitionId}/publish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteFormsPublicApi {
    public static getFormsPublicGetForm<ThrowOnError extends boolean = false>(options: Options<GetFormsPublicGetFormData, ThrowOnError>): RequestResult<GetFormsPublicGetFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormsPublicGetFormResponses, unknown, ThrowOnError>({ url: '/public/forms/{tenantId}/{id}', ...options });
    }
    
    public static optionsFormsPublicGetFormPreflight<ThrowOnError extends boolean = false>(options: Options<OptionsFormsPublicGetFormPreflightData, ThrowOnError>): RequestResult<OptionsFormsPublicGetFormPreflightResponses, unknown, ThrowOnError> {
        return (options.client ?? client).options<OptionsFormsPublicGetFormPreflightResponses, unknown, ThrowOnError>({ url: '/public/forms/{tenantId}/{id}', ...options });
    }
    
    public static optionsFormsPublicSubmitFormPreflight<ThrowOnError extends boolean = false>(options: Options<OptionsFormsPublicSubmitFormPreflightData, ThrowOnError>): RequestResult<OptionsFormsPublicSubmitFormPreflightResponses, unknown, ThrowOnError> {
        return (options.client ?? client).options<OptionsFormsPublicSubmitFormPreflightResponses, unknown, ThrowOnError>({ url: '/public/forms/{tenantId}/{formId}/{definitionId}/submissions', ...options });
    }
    
    public static postFormsPublicSubmitForm<ThrowOnError extends boolean = false>(options: Options<PostFormsPublicSubmitFormData, ThrowOnError>): RequestResult<PostFormsPublicSubmitFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsPublicSubmitFormResponses, unknown, ThrowOnError>({
            url: '/public/forms/{tenantId}/{formId}/{definitionId}/submissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static optionsFormsPublicResolveZipPreflight<ThrowOnError extends boolean = false>(options: Options<OptionsFormsPublicResolveZipPreflightData, ThrowOnError>): RequestResult<OptionsFormsPublicResolveZipPreflightResponses, unknown, ThrowOnError> {
        return (options.client ?? client).options<OptionsFormsPublicResolveZipPreflightResponses, unknown, ThrowOnError>({ url: '/public/forms/{tenantId}/{id}/resolve-zip', ...options });
    }
    
    public static postFormsPublicResolveZip<ThrowOnError extends boolean = false>(options: Options<PostFormsPublicResolveZipData, ThrowOnError>): RequestResult<PostFormsPublicResolveZipResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostFormsPublicResolveZipResponses, unknown, ThrowOnError>({
            url: '/public/forms/{tenantId}/{id}/resolve-zip',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SuiteFormSubmissionsApi {
    public static getFormSubmissionsGetSubmissions<ThrowOnError extends boolean = false>(options?: Options<GetFormSubmissionsGetSubmissionsData, ThrowOnError>): RequestResult<GetFormSubmissionsGetSubmissionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetFormSubmissionsGetSubmissionsResponses, unknown, ThrowOnError>({ url: '/forms/submissions', ...options });
    }
    
    public static getFormSubmissionsGetSubmissionRenderHtml<ThrowOnError extends boolean = false>(options: Options<GetFormSubmissionsGetSubmissionRenderHtmlData, ThrowOnError>): RequestResult<GetFormSubmissionsGetSubmissionRenderHtmlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormSubmissionsGetSubmissionRenderHtmlResponses, unknown, ThrowOnError>({ url: '/forms/submissions/{id}/render-html', ...options });
    }
    
    public static getFormSubmissionsGetSubmissionRenderPdf<ThrowOnError extends boolean = false>(options: Options<GetFormSubmissionsGetSubmissionRenderPdfData, ThrowOnError>): RequestResult<GetFormSubmissionsGetSubmissionRenderPdfResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetFormSubmissionsGetSubmissionRenderPdfResponses, unknown, ThrowOnError>({ url: '/forms/submissions/{id}/render-pdf', ...options });
    }
}

export class SuiteItFreshdeskBridgePublicApi {
    public static getItFreshdeskBridgePublicGetConfig<ThrowOnError extends boolean = false>(options: Options<GetItFreshdeskBridgePublicGetConfigData, ThrowOnError>): RequestResult<GetItFreshdeskBridgePublicGetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetItFreshdeskBridgePublicGetConfigResponses, unknown, ThrowOnError>({ url: '/public/it/freshdesk/bridge/config', ...options });
    }
    
    public static postItFreshdeskBridgePublicSubmitForm<ThrowOnError extends boolean = false>(options: Options<PostItFreshdeskBridgePublicSubmitFormData, ThrowOnError>): RequestResult<PostItFreshdeskBridgePublicSubmitFormResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostItFreshdeskBridgePublicSubmitFormResponses, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/submit',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getItFreshdeskBridgePublicStartSso<ThrowOnError extends boolean = false>(options: Options<GetItFreshdeskBridgePublicStartSsoData, ThrowOnError>): RequestResult<GetItFreshdeskBridgePublicStartSsoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetItFreshdeskBridgePublicStartSsoResponses, unknown, ThrowOnError>({ url: '/public/it/freshdesk/bridge/sso/start', ...options });
    }
    
    public static postItFreshdeskBridgePublicGenerateSsoToken<ThrowOnError extends boolean = false>(options: Options<PostItFreshdeskBridgePublicGenerateSsoTokenData, ThrowOnError>): RequestResult<PostItFreshdeskBridgePublicGenerateSsoTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostItFreshdeskBridgePublicGenerateSsoTokenResponses, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/sso/generate-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
